import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, withTheme } from 'styled-components';

// Import styles
import { flex } from 'components/styles';

// Import components
import { ProgramRecordings } from 'components/elements';
import Share from './share/Share';
import { Reminder } from '../../common';

// Import utilities
import { useAuth } from 'components/utilities';
import useProgramToolbar from 'components/views/tv/program_details/program_toolbar/useProgramToolbar';

const PopoverToolbox = ({
	reminderId,
	programId,
	isUpcoming = false,
	theme,
	startDate
}) => {
	const { isAuth } = useAuth();
	const {
		isRecordingsPanelVisible,
		isDvrActive,
		isNpvrActive
	} = useProgramToolbar();
	const reminderProps = { reminderId, theme, programId, startDate };
	return (
		<ToolBox>
			{isUpcoming && isAuth && (
				<Box>
					<Reminder {...reminderProps} />
				</Box>
			)}

			{isAuth && isRecordingsPanelVisible && (
				<Box>
					<ProgramRecordings
						programId={programId}
						isDvrActive={isDvrActive}
						isNpvrActive={isNpvrActive}
					/>
				</Box>
			)}
			<Box>
				<Share />
			</Box>
		</ToolBox>
	);
};

const ToolBox = styled.div`
	height: 7rem;
	display: flex;
	justify-content: space-between;
`;

const Box = styled.div`
	flex: 1;
	${flex()}

	&:nth-child(2) {
		border-left: 1px solid ${({ theme: { popover } }) => popover.border};
		border-right: 1px solid ${({ theme: { popover } }) => popover.border};
	}
	&:last-child {
		border-right: 1px solid transparent;
	}

	svg {
		height: 3rem;
		width: 3rem;
	}

	${({ isCatchup }) =>
		isCatchup &&
		css`
			svg {
				g,
				path {
					fill: ${({ theme }) => theme.orange};
				}
			}
		`}
`;

PopoverToolbox.propTypes = {
	isUpcoming: PropTypes.bool.isRequired,
	programId: PropTypes.string.isRequired,
	reminderId: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([false])])
};

export default withTheme(PopoverToolbox);
